import { doodBlockConfig, propertyValue } from "./dood-block-config";
import { cartPagePresetBlockBackgroundColorProperty } from "./cart-page-preset-block-background.util";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

/**
 * Serializable preview VM for `CartVoucherBlockComponent`.
 * Kept in content-builder so dashboard + webapp share the same transport shape.
 */
export type CartVoucherBlockScenarioContent = {
  isVisible: boolean;
};

/** Legacy CB1 field order for `CartVoucherBlock`. */
export const CART_VOUCHER_LEGACY_FIELD_ORDER = [
  { type: "heading", value: "Couleurs" },
  "heading_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartVoucherBlockDescriptor: _generatedCartVoucherBlockDescriptor,
  cartVoucherBlockBlocDefinition,
  cartVoucherBlockDashboardLayout,
  cartVoucherBlockConfig,
  cartVoucherBlockResolveConfig,
  cartVoucherBlockProperties,
  cartVoucherBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    id: "cart-voucher-block",
    name: "Cart - Voucher",
    componentType: "CartVoucherBlockComponent",
    category: "cart",
    description: "Cart voucher entry block.",
    keywords: ["cart", "voucher", "coupon"],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],


    sharedFields: {},
  },

  () => ({
    background_color: cartPagePresetBlockBackgroundColorProperty(),
    heading_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-800" },
      options: { label: "pages.blocks.cart-voucher.heading-color.label" },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-voucher.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-page.fieldset.appearance.label",
            fields: ["background_color"],
          },
          {
            legend: "pages.blocks.cart-voucher.fieldset.title.label",
            fields: ["heading_color"],
          },
        ],
      },
    ],
  })
);

export function cartVoucherBlockDescriptor(): IBlockDescriptor;
export function cartVoucherBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartVoucherBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartVoucherBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedCartVoucherBlockDescriptor,
    cartVoucherBlockProperties,
    fieldOrder,
  );
}

export {
  cartVoucherBlockBlocDefinition,
  cartVoucherBlockDashboardLayout,
  cartVoucherBlockConfig,
  cartVoucherBlockResolveConfig,
  cartVoucherBlockProperties,
  cartVoucherBlockDefinitionSetupScenarios,
};

export type CartVoucherBlockConfig = typeof cartVoucherBlockConfig;
